import Chart from 'react-apexcharts';

function LineBarChart({
  title = '',
  categories = [],
  series = [],
  width = '100%',
  height = 280,
  leftAxisLabel = '',
  rightAxisLabel = '',
  lineSeriesName = '',
  lineSeriesFormatter = null,
  barSeriesName = '',
  barSeriesFormatter = null,
}) {
  const hasVariance = series.some((data) => data.name === lineSeriesName);
  const yaxis = [
    ...(hasVariance ? [{
      seriesName: lineSeriesName,
      opposite: true,
      axisTicks: { show: false },
      axisBorder: {
        show: false,
      },
      title: { text: rightAxisLabel },
      min: 0,
      tooltip: { enabled: false },
      labels: { show: true, formatter: lineSeriesFormatter, offsetX: -5 },
    }] : []),
    {
      seriesName: barSeriesName,
      axisTicks: { show: false },
      axisBorder: {
        show: false,
      },
      title: { text: leftAxisLabel },
      tooltip: { enabled: false },
      labels: { show: true, formatter: barSeriesFormatter, offsetX: -20 },
    },
    {
      seriesName: barSeriesName,
      show: false,
      labels: { formatter: barSeriesFormatter },
    },
  ];

  const chartOptions = {
    title: {
      text: title,
    },
    chart: {
      animations: {
        enabled: false,
      },
      events: {
        mounted(chartContext) {
          // Hide the Righthand side series by default
          chartContext.toggleSeries(rightAxisLabel);
        },
      },
    },
    xaxis: {
      categories,
      labels: {
        offsetY: 5,
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: true,
      },
      tickPlacement: 'between',
      tooltip: { enabled: false },
    },
    yaxis,
    grid: {
      padding: {
        left: -15,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      floating: false,
      offsetY: 5,
      itemMargin: {
        vertical: 0,
      },
    },
    tooltip: {
      shared: true,
      followCursor: true,
    },
  };

  return <Chart options={chartOptions} series={series} type="line" width={width} height={height} />;
}

export default LineBarChart;
